// extracted by mini-css-extract-plugin
export default {"mainHeader":"dashboardContainer_mainHeader__IqFUI","mainContainer":"dashboardContainer_mainContainer__BY4xk","userIcon":"dashboardContainer_userIcon__ui9fO"};